import { render, staticRenderFns } from "./ContactOpportunities.vue?vue&type=template&id=c3a4c798&scoped=true&"
import script from "./ContactOpportunities.vue?vue&type=script&lang=js&"
export * from "./ContactOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./ContactOpportunities.vue?vue&type=style&index=0&id=c3a4c798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a4c798",
  null
  
)

export default component.exports